export default __webpack_public_path__ + "static/media/plus.4f287d0a.svg";